export default __webpack_public_path__ + "static/media/default-monochrome.1b77531e.svg";